import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store"
import Vuebar from "vuebar";
import "./plugins/base";
import api from "./api";
import bus from "./bus";
import InitController from "./utils/InitController" 
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueSkycons from "vue-skycons";
import detectMobile from "./DetectecMobile"
import VueHtmlToPaper from 'vue-html-to-paper';
import ForceDownload from "./ForceDownload";
Vue.use(VueSkycons, {
  color: "#cc1d05",
});

Vue.prototype.$bus = bus;
Vue.prototype.$api = api;
Vue.config.productionTip = false;
Vue.use(Vuebar);

Vue.prototype.$mobile = detectMobile;
Vue.prototype.$fileDownload = ForceDownload;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.prototype.$getDate = () => {

  let d = new Date();
  let a = d.getFullYear();
  let m = d.getMonth()+1;
  let dy = d.getDate();

  return `${a}_${m}_${dy}`

}

InitController.start();

// or, using the defaults with no stylesheet
Vue.use(VueHtmlToPaper);
new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
